import SiafLiteApiRepository from "../../external/siafLiteApi";

class SituacaoPisService {
  constructor() {
    this.urlBase = "/fiscal/situacoes-pis";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default SituacaoPisService;
